import React from "react";
import Ptemp from "./Ptemp";

export default function Project() {
  return (
    <div className="work">
      <h1 className="heading two">Projects</h1>
      <div className="flex-container projects">
        <Ptemp 
          name="Vision System" 
          link="https://github.com/Ranilbala" 
          description="Engineered a defect detection system using YOLO and Python, achieving 99% accuracy. Built a Tkinter-based GUI for stakeholders to visualize and analyze defects, seamlessly integrated with the detection algorithms."
          buildwith="Python, YOLO, OpenCV, Tkinter"
        />
        <Ptemp 
          name="PPE Detection" 
          link="https://github.com/Ranilbala" 
          description="Developed a real-time safety monitoring system using YOLOv8 for detecting Personal Protective Equipment (PPE). Integrated with Django and SQLite for web interface and data management, ensuring end-to-end full-stack functionality."
          buildwith="Python, Django, SQL, YOLOv8"
        />
        <Ptemp 
          name="Meme-Generator" 
          link="https://ranilbala.github.io/meme_generator/" 
          description="Imgflip-powered meme generator for creating personalized memes with custom text and sharing. Utilizes Imgflip API for popular meme templates."
          buildwith="Html, Css, Js, React"
        />
        <Ptemp 
          name="Weather-App" 
          link="https://ranilbala.github.io/weather_app/" 
          description="Developed weather app with real-time updates and enhanced functionality via OpenWeather and GeoDB APIs. User-friendly with clean interface."
          buildwith="Html, Css, Js, React"
        />
        <Ptemp 
          name="Portfolio" 
          link="https://ranilbala.netlify.app/" 
          description="Created visually appealing website with responsive design and intuitive interface showcasing past projects and experiences."
          buildwith="Html, Css, Js, React"
        />
        <Ptemp 
          name="Shopping-Meet" 
          link="https://github.com/Ranilbala/Shopping-Meet.git" 
          description="React/WebRTC video calling app providing efficient real-time connections with high-quality video/audio. User-friendly interface powered by React and WebRTC technology."
          buildwith="Html, Css, Js, React, WebRTC"
        />
        <Ptemp 
          name="Blog" 
          link="https://github.com/Ranilbala/blog.git" 
          description="Django/SQLite blog platform that displays user posts with a clean interface. Allows effortless content sharing via a simple yet powerful framework."
          buildwith="Html, Css, Js, Django"
        />
      </div>
    </div>
  );
}
